/** Pointer interactions may use decorative motion; keyboard work stays immediate. */
let lastInput: 'pointer' | 'keyboard' = 'keyboard';
if (typeof window !== 'undefined') {
  window.addEventListener('pointerdown', () => { lastInput = 'pointer'; }, true);
  window.addEventListener('keydown', () => { lastInput = 'keyboard'; }, true);
}

export function shouldAnimateInteraction(): boolean {
  return typeof window !== 'undefined'
    && lastInput === 'pointer'
    && !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
}
